module.exports = __webpack_public_path__ + "img/explicacao.64e3e176.png";